import { ObjectManager } from '../../../concepts/objects';
import { AudioManager } from '../../../platform/AudioManager';
import { EditorSession } from '../../canvas/EditorSession';
import { WidgetManager } from '../../canvas/workspace/widgets/WidgetManager';
import { ActiveObject, resolve } from '../../Container';

export class CounterMechanics extends ActiveObject {

    @resolve(AudioManager) private readonly audio!: AudioManager;
    @resolve(ObjectManager) private readonly objects!: ObjectManager;
    @resolve(EditorSession) private session: EditorSession;
    @resolve(WidgetManager) private widgets: WidgetManager;

    public start(): void {
        this.burden(
            // this.objects.on('Counter', 'released', this.silenceDeletedBox),
            // this.objects.createTrigger('Counter.forceSync')
            //     .for(Counter).onChangesTo('isPlaying', 'playingFromIndex', 'playingSince').doForEach(this.syncCounter),
            // this.session.observe(AdapterInfo, this.realizeCounterAdapter),
            // this.startInterval(),
            // () => this.silenceAllMusic(),
        );
    }
}
